import { useState } from 'react';
import { accountingSystemConfig, getConnectableAccountingSystems } from 'shared';

import { Card } from '../../common/Atoms/Card';
import { MultiButtonCardHeader } from '../../common/Atoms/MultiButtonCardHeader';
import { Notification } from '../../common/Atoms/Notification';
import { Button } from '../../common/Atoms/Button';
import { env } from '../../common/lib/env';

import { AccountingConnectButton } from './AccountingConnectButton';
import { PendingInvitations } from './Common/PendingInvitations';
import { CreateInternalOrganisationModal } from './CreateInternalOrganisationModal';

export function NoOrganisationsConnected() {
  const connectable = getConnectableAccountingSystems();
  const systemNames = connectable.map(type => accountingSystemConfig[type].provider.displayName).join(` or `);
  const [internalModalOpen, setInternalModalOpen] = useState(false);

  return (
    <>
      <PendingInvitations showContentOnly={ false } />
      <Card>
        <MultiButtonCardHeader
          title={ `Get started: connect to ${systemNames}` }
          description={ `To get started connect to ${systemNames} by clicking the button below. Don't worry, once you connect Paidnice won't change anything in your accounting system until you are ready.` }
        />

        <div className={ `w-full grid grid-cols-3 mt-8` }>
          <div className={ `col-span-1` }></div>
          <div className={ `col-span-1 flex justify-center gap-2` }>
            { connectable.map(type => <AccountingConnectButton key={ type }
              type={ type } />) }
          </div>
        </div>
        { env.isDev && (
          <div className={ `flex justify-center mt-4` }>
            <Button
              color={ `gray` }
              onClick={ () => setInternalModalOpen(true) }
            >
              { `Create Internal organisation (dev only)` }
            </Button>
            <CreateInternalOrganisationModal
              open={ internalModalOpen }
              onClose={ () => setInternalModalOpen(false) }
            />
          </div>
        ) }
        <div
          className={ `flex mt-64 justify-center` }
        >
          <Notification
            className={ `max-w-2xl` }
            type={ `info` }
            title={ `Joining an existing organisation?` }
          >
            { `If someone else has already connected your organisation to Paidnice, you just need to connect the same organisation yourself to gain access.` }
          </Notification>
        </div>
      </Card>
    </>
  );
}
